<form [formGroup]="formGroup">
  <h2>
    <div class="row-left">
      Project Filter
      <button
        mat-button
        type="button"
        class="btnNegative"
        (click)="onResetClicked()"
      >
        Reset
      </button>
    </div>

    <div class="col">
      <h3 class="row">Technology Master Filter</h3>
      <digires-project-filter-technology></digires-project-filter-technology>
    </div>

    <div class="row-right" style="width: 223.56px;">
      <button
        mat-button
        type="button"
        class="btnNeutral"
        (click)="onApplyClicked()"
      >
        Apply
      </button>
      <button mat-icon-button type="button" (click)="onClose.emit()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </h2>

  <h3 class="row">Project Information</h3>

  <section>

    <digires-text-input [formGroup]="formGroup"
                        formCtrlName="name"
                        placeholder="Project Name"
                        tooltip="Shows only those projects where the entered text appears as part of the projects name."
    ></digires-text-input>

    <digires-multi-list-input [formGroup]="formGroup"
                              [multiSelect]="true"
                              [items]="allStatuses"
                              [itemToLabel]="statusToLabel"
                              noItemName="All Statuses"
                              formCtrlName="status"
                              placeholder="Project Status"
                              tooltip="Shows only projects within either of the selected statuses."
    ></digires-multi-list-input>

    <digires-autocomplete-input class="full-width"
                                [formGroup]="formGroup"
                                [items]="allManagers"
                                [itemToId]="managerToId"
                                [itemToLabel]="managerOrUserIdToLabel.bind(this)"
                                formCtrlName="projectManager"
                                placeholder="Project Manager"
                                tooltip="Shows only projects managed by either of the selected managers."
    ></digires-autocomplete-input>

    <digires-list-input [formGroup]="formGroup"
                        [items]="allMyProjectsFilterOptions"
                        [itemToLabel]="myProjectsFilterOptionToLabel"
                        formCtrlName="myProjects"
                        placeholder="My Projects"
                        tooltip="Shows only projects where the User is identified in the project team based on the
                        roles selected in the filter."
    ></digires-list-input>

    <div></div>

    <digires-multi-list-input [formGroup]="formGroup"
                              [multiSelect]="true"
                              [items]="allManagingAppModes"
                              [itemToLabel]="managingApplicationModeToLabel"
                              noItemName="All Modes"
                              formCtrlName="managingApplicationMode"
                              placeholder="Managing Application Mode"
                              tooltip="Shows only projects where the 'Managing Application Mode' is as selected"
    ></digires-multi-list-input>

    <digires-multi-list-input [formGroup]="formGroup"
                              [multiSelect]="true"
                              [items]="allManagingApps"
                              [itemToLabel]="managingApplicationToLabel"
                              noItemName="All Projects"
                              formCtrlName="managingApplication"
                              placeholder="Managing Application"
                              tooltip="Shows only projects where the 'Managing Application' is as selected"
    ></digires-multi-list-input>

    <digires-multi-list-input [formGroup]="formGroup"
                              [multiSelect]="true"
                              [items]="allPhases"
                              [itemToLabel]="phaseToLabel"
                              noItemName="All Phases"
                              formCtrlName="phase"
                              placeholder="Project Phase"
                              tooltip="Shows only projects within either of the selected phases."
    ></digires-multi-list-input>

    <digires-multi-list-input [formGroup]="formGroup"
                              [multiSelect]="true"
                              [items]="allStages"
                              [itemToLabel]="stageToLabel"
                              noItemName="All Stages"
                              formCtrlName="stage"
                              placeholder="Project Stage"
                              tooltip="Shows only projects within either of the selected stages."
    ></digires-multi-list-input>

    <digires-multi-list-input [formGroup]="formGroup"
                              [multiSelect]="true"
                              [items]="allBusinessModels"
                              [itemToLabel]="businessModeToLabel"
                              noItemName="All Business Models"
                              formCtrlName="businessModel"
                              placeholder="Business Model"
                              tooltip="Shows only projects within either of the selected business models."
    ></digires-multi-list-input>

    <digires-multi-list-input [formGroup]="formGroup"
                              [multiSelect]="true"
                              [items]="allRouteToMarket"
                              [itemToLabel]="routeToMarketToLabel"
                              noItemName="All Route to market"
                              formCtrlName="routeToMarket"
                              placeholder="Route To Market"
                              tooltip="Shows only projects within either of the selected route to market."
    ></digires-multi-list-input>

    <digires-list-input [formGroup]="formGroup"
                        [items]="allHybridProjectFilterOptions"
                        [itemToLabel]="hybridProjectFilterOptionToLabel"
                        formCtrlName="hybridProject"
                        placeholder="Hybrid Project"
                        tooltip="Shows all projects or only projects that are identified as containing multiple
                        technologies (Hybrid Only) or a single technology (Non-Hybrid Only)."
    ></digires-list-input>

    <digires-multi-list-input [formGroup]="formGroup"
                              [multiSelect]="true"
                              [items]="allTypes"
                              [itemToLabel]="typeToLabel"
                              noItemName="All Types"
                              formCtrlName="type"
                              placeholder="Project Type"
                              tooltip="Shows only projects of either of the selected types."
    ></digires-multi-list-input>

    <digires-multi-list-input [formGroup]="formGroup"
                              [multiSelect]="true"
                              [items]="allProjectValidations"
                              [itemToLabel]="projectValidationToLabel"
                              noItemName="All Projects"
                              formCtrlName="projectValidation"
                              placeholder="Project Validations"
                              tooltip="Shows only projects where the selected Validation option is in place."
    ></digires-multi-list-input>

    <digires-list-input [formGroup]="formGroup"
                        [items]="allValidationLocks"
                        [itemToLabel]="validationLockToLabel"
                        formCtrlName="validationLock"
                        placeholder="Validation Lock"
                        tooltip="Shows only projects where the selected Validation Lock option is in place."
    ></digires-list-input>

  </section>

  <h3 class="row">Location</h3>

  <section>

    <digires-multi-list-input *ngIf="allCountryCodes"
                              [formGroup]="formGroup"
                              [multiSelect]="true"
                              [items]="allCountryCodes"
                              [itemToLabel]="countryCodeToLabel"
                              noItemName="All Countries"
                              formCtrlName="country"
                              placeholder="Country"
                              tooltip="Shows only projects within either of the selected countries."
    ></digires-multi-list-input>

    <digires-multi-list-input [formGroup]="formGroup"
                              [multiSelect]="true"
                              [items]="allGlobalRegions"
                              [itemToLabel]="globalRegionToLabel"
                              noItemName="All Global Regions"
                              formCtrlName="globalRegion"
                              placeholder="RWE Renewables Global Region"
                              tooltip="Shows only projects within either of the selected global regions."
    ></digires-multi-list-input>

    <digires-group-multi-input [formGroup]="formGroup"
                               [groups]="allRegions"
                               [itemToLabel]="regionToLabel"
                               noItemName="All Regions"
                               formCtrlName="region"
                               placeholder="Regions"
                               tooltip="The Values for the Region are what has been selected for use by each Country team.
                               The total list of Regions is very long but if you select Country first then the Region filter
                               adjusts to show only the Regions in the select Country (or Countries.)"
    ></digires-group-multi-input>

    <digires-multi-list-input [formGroup]="formGroup"
                              [multiSelect]="true"
                              [items]="allDevelopmentDirectorates"
                              [itemToLabel]="directorateToLabel"
                              noItemName="All Development Directorates"
                              formCtrlName="developmentDirectorate"
                              placeholder="Development Directorate (N1)"
                              tooltip="Shows only projects within either of the selected development directorates."
    ></digires-multi-list-input>

    <div><!--Intentionally left blank--></div>

    <digires-multi-list-input [formGroup]="formGroup"
                              [multiSelect]="true"
                              [items]="allConstructionClusters"
                              [itemToLabel]="consClusterToLabel"
                              noItemName="All Clusters"
                              formCtrlName="consCluster"
                              placeholder="Construction Clusters"
                              tooltip="Shows only projects within either of the selected construction clusters."
    ></digires-multi-list-input>

    <div><!--Intentionally left blank--></div>

    <digires-multi-dropdown-input configId="team-location"
                            [formGroup]="formGroup"
                            formCtrlName="teams"
                            noItemName="All Teams"
                            placeholder="Team"
                            [useDisable]="false"
                            tooltip="Shows only projects being managed by the selected Teams."
    ></digires-multi-dropdown-input>

  </section>

</form>
